require.register("app/ui/Modal", function(exports, require, module){
  $0
  
});

